
import { HttpEvent, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from '../../environments/environment';

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const token = localStorage.getItem('access_token');
  const router = inject(Router);

  // Si es entorno local (localhost), no validar el token
  if (environment.backendUrl.includes('localhost')) {
    if (token) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }
    return next(req);
  }

  function isTokenExpired(token: string): boolean {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (!payload.exp) return true;
      const now = Math.floor(Date.now() / 1000);
      return payload.exp < now;
    } catch (e) {
      return true;
    }
  }
  if (token) {
    if (isTokenExpired(token)) {
      localStorage.removeItem('access_token');
      console.log("linea 24 jwt interceptor")
      window.location.href = environment.portalUrl + 'auth/iniciar-sesion';
    } else {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }
  }
  return next(req);
}
